<template src="./Feedback.html" />

<script lang="js">

import Vue from "vue";
import EmojiRating from "./emojirating/EmojiRating";
import axios from "axios";
import {AnalyzeIdentifier} from "@/plugins/analyzeIdentifier";

export default Vue.extend({
  name: "nmouc-feedback",
  components: {
    EmojiRating,
  },
  data() {
    return {
      feedbackSubmitted: false,
      inputIsValid: true,
      rating: 0,
      comment: "",
      feedbackError: false,
    }
  },
  mounted() {
    this.feedbackSubmitted = false
  },
  computed: {
    feedbackSendable: function() {
      return this.feedbackError === false && this.inputIsValid && this.rating > 0 && this.rating <= 3;
    },
    analyzeIdentifier: function() {
      return AnalyzeIdentifier.ID;
    },
    hint: function () {
      return this.inputIsValid ? this.$t('feedback.comment.hint.valid') : this.$t('feedback.comment.hint.invalid');
    }
  },
  methods: {
    handleRatingChange: function (value) {
      this.rating = value
    },
    isFeedbackSubmitted() {
      return this.feedbackSubmitted
    },
    sendFeedback() {
      if (this.feedbackSendable) {
        axios.post(`/feedback/api/v1/userfeedback`,
            {
              rating: this.rating,
              comment: this.comment
            },
            {
              withCredentials: true
            })
            .then(() => {
              this.feedbackSubmitted = true
            })
            .catch((error) => {
              console.error("error", error);
              this.feedbackError = true
            })
      }
    },
    close() {
      this.feedbackSubmitted = false
      this.feedbackError = false
      this.rating = 0
      this.comment = ""
    },
    validateInput() {
      let specials = RegExp(/[*|+"<>[\]{}`\\';@$]/)
      this.inputIsValid = specials.test(this.comment) === false
    }
  }
});
</script>
<style></style>
